<template>
  <div class="lz-field">
    <label class="lz-field-label">Type</label>
    <b-form-select
      v-model="selectedType"
      :options="holidayTypeOptions"
      @change="typeChanged"
      size="sm">
    </b-form-select>
  </div>
</template>

<script>
import ServicesOld from '../../services/index.vue'

export default {
  name: 'holidayTypeSelector',
  data() {
    return {
      selectedType: null,
      holidayTypeOptions: [
        { value: null, text: 'Select your request type', disabled: true }
      ]
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    FormData() {
      return this.Store.formData
    },
    selectedHolidayType() {
      return this.FormData.selectedHolidayType
    },
    selectedYear() {
      return this.Store.newHolidaySelectedYear
    }
  },
  async mounted() {
    await this.getHolidayTypeOptions()
  },
  methods: {
    async getHolidayTypeOptions() {
      const holidayTypeOptions = await ServicesOld.GetHolidayTypeOptions({
        year: this.selectedYear
      })
      if (holidayTypeOptions.status == 200) {
        this.holidayTypeOptions = this.holidayTypeOptions.splice(0, 1)
        this.holidayTypeOptions = this.holidayTypeOptions.concat(
          holidayTypeOptions.data.content.filter((itm) => {
            return itm.sort > -1
          })
        )
        const halfDayIndex = this.holidayTypeOptions.findIndex(
          (itm) => itm.value == 'HALFDAY'
        )
        this.holidayTypeOptions[halfDayIndex].value = 'HALFDAYAM'
        this.holidayTypeOptions[halfDayIndex].text = 'Half-Day Holiday (AM)'
        this.holidayTypeOptions.push({
          sort: this.holidayTypeOptions[halfDayIndex].sort + 0.1,
          value: 'HALFDAYPM',
          text: 'Half-Day Holiday (PM)'
        })
        this.holidayTypeOptions = this.holidayTypeOptions.sort((a, b) => {
          if (a.sort < b.sort) return -1
          if (a.sort > b.sort) return 1
          return 0
        })
        this.$root.$emit('holidayTypeOptions', this.holidayTypeOptions)
      }
    },
    typeChanged() {
      const halfDayRegEx = new RegExp(/^HALFDAY[A-Z]M$/i)
      const personalHalfDayRegEx = new RegExp(/^HALFPERSONAL$/i)
      const isHalfDay = halfDayRegEx.test(this.selectedType)
      const isPersonalHalfDay = personalHalfDayRegEx.test(this.selectedType)
      this.$store.commit('modifyFormData', {
        key: 'holidayType',
        value: isHalfDay ? 'HALFDAY' : this.selectedType
      })
      if (isHalfDay) {
        this.$store.commit('modifyFormData', {
          key: 'holidayHalfDayMeridiem',
          value: this.selectedType.substr(this.selectedType.length - 2)
        })
      }
    }
  }
}
</script>

<style>
label.btn-outline-info {
  padding: 0 !important;
  line-height: 30px !important;
}
</style>
